/**
 * @boringnode/bus
 *
 * @license MIT
 * @copyright BoringNode
 */

import { debuglog } from 'node:util'

export default debuglog('boringnode:bus')
